import { Type } from 'class-transformer';
import { IsNumber, IsOptional, Max, Min } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { PagedRequest, PagedResponse } from '../request';
import { DEFAULT_ADMIN_PER_PAGE_MAX } from '../../const/pagination';
import type { SortableRequest, Sorters } from '../sortable';
import type { FilterableValue } from '../filterable';
import { DateISOString } from '../../types';
import { ClientType } from '../client/clientType';
import { CareerId } from '../../const/catalog/career';
import { DealViewModel } from './view';
import { DealStatus } from './const';

type SortableFields = 'createdAt' | 'updatedAt' | 'status' | 'price' | 'oldPrice' | 'endedAt' | 'startedAt';

export class DealListResponse implements PagedResponse<DealViewModel> {
  items: DealViewModel[];
  totalCount: number;
}

export class DealListRequest implements PagedRequest, SortableRequest {
  @Type(() => Number)
  @IsOptional()
  @IsNumber()
  @Min(1)
  @ApiProperty({
    description: 'The number of page',
    example: 1,
    required: false,
  })
  page?: number | undefined;

  @Type(() => Number)
  @IsOptional()
  @IsNumber()
  @Max(DEFAULT_ADMIN_PER_PAGE_MAX)
  @ApiProperty({
    description: 'The number of items per page',
    example: 10,
  })
  pagination?: number | undefined;

  @ApiProperty()
  @IsOptional()
  status?: FilterableValue<DealStatus>;

  @ApiProperty()
  @IsOptional()
  createdAt?: FilterableValue<DateISOString>;

  @ApiProperty()
  @IsOptional()
  startedAt?: FilterableValue<DateISOString>;

  @ApiProperty()
  @IsOptional()
  endedAt?: FilterableValue<DateISOString>;

  @ApiProperty()
  @IsOptional()
  typeOfInitiator?: FilterableValue<ClientType>;

  @ApiProperty()
  @IsOptional()
  initiatorCityId?: FilterableValue<number>;

  @ApiProperty()
  @IsOptional()
  providerCareerId?: FilterableValue<CareerId>;

  @ApiProperty()
  @IsOptional()
  price?: FilterableValue<number>;

  @ApiProperty()
  @IsOptional()
  phoneOrEmail?: FilterableValue<string>;

  @ApiProperty({ description: 'Related vacancy' })
  @IsOptional()
  vacancyId?: FilterableValue<number>;

  @ApiProperty()
  @IsOptional()
  @IsNumber()
  @Type(() => Number)
  clientId?: number;

  @ApiProperty()
  @IsOptional()
  sorters?: Sorters<SortableFields>;
}
